import React from "react";
import { Link } from "react-router-dom";

interface NotFoundPageProps {
  [key: string]: any;
}

function NotFoundPage(props: NotFoundPageProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white px-4">
      <h1 className="text-6xl font-bold text-gray-900">404</h1>
      <p className="mt-4 text-lg text-gray-700">Page not found</p>
      <Link
        to="/"
        className="mt-6 px-6 py-2 rounded-lg border border-gray-400 text-gray-800 hover:bg-gray-100 transition"
      >
        Go Home
      </Link>
    </div>
  );
}

export default NotFoundPage;
